import $ from 'jquery'
export default class YouTubeVideoPlayer {
  constructor({ containerId, videoId, height = `100%`, width = `100%` }) {
    const options = {
      height,
      width,
      videoId,
      playerVars: {
        controls: 0,
        fs: 0,
        loop: 1,
        rel: 0,
        modestbranding: 1
      },
      events: {
        onReady: this.onPlayerReady,
        onStateChange: this.onPlayerStateChange
      }
    }
    this.containerId = containerId
    this.options = options
    this.customPlayIcon(`.yt-custom-play-icon`)
  }

  // Custom method
  loadYoutubeiFrame() {
    $(`.yt-custom-play-icon`).fadeOut(`fast`, () => {
      this.player = new window.YT.Player(this.containerId, this.options)
    })
  }
  customPlayIcon(selector) {
    if (!selector || selector === undefined) {
      return false
    }
    $(selector).on(`click`, () => {
      this.loadYoutubeiFrame()
    })
  }
  // The API calls this function when the player's state changes.
  // Other Optional Methods are:
  // onPlayerReady(event) {}
  // onPlayerStateChange(event) {}

  // Helper Functions Play and Stop Video
  playVideo() {
    this.player.playVideo()
  }
  stopVideo() {
    this.player.stopVideo()
  }
}
